export const formatDate = (inputDate) => {
  const dateObj = new Date(inputDate);
  const options = { day: "numeric", month: "short", year: "numeric" };
  return dateObj.toLocaleDateString("en-GB", options);
};

export const dateTimeFormat = (inputDate) => {
  const currentDate = new Date(inputDate); // Current date and time
  const formattedDate = currentDate
    .toISOString()
    .slice(0, 19)
    .replace("T", " "); // Format: YYYY-MM-DD HH:MI:SS
  return formattedDate;
};

export const formatDateYMD = (inputDate) => {
  // console.log("date", inputDate);
  // const dateObj = new Date(inputDate);
  // console.log("dateObj", dateObj);
  // const formattedDate = dateObj.toISOString().split("T")[0];
  // console.log("formattedDate", formattedDate);

  const dateObj = new Date(inputDate);

  // Get year, month, and day values from the date object
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");

  // Format the date using the extracted values
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
};

export const dateDifference = (date1, date2) => {
  const difference = new Date(date2) - new Date(date1);
  const millisecondsInADay = 1000 * 60 * 60 * 24;

  return Math.floor(difference / millisecondsInADay);
};

export const formatNumber = (number) => {
  // Use toLocaleString to add commas and round to two decimal places
  return number.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
